import { __awaiter } from "tslib";
import { reaction } from "mobx";
import { debounce } from "lodash";
export const kActivityDebounceDelay = 150;
export class GroupActivityBroadcaster {
    constructor(db) {
        Object.defineProperty(this, "db", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "onDisconnectHandler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "onDisconnectGroupId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "flush", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "flushNow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const { ui, persistentUI, user } = this.db.stores;
                const groupId = user.currentGroupId;
                const documentKey = persistentUI.problemWorkspace.primaryDocumentKey;
                const tileIds = ui.selectedTileIds.slice();
                if (!groupId)
                    return;
                if (!documentKey || tileIds.length === 0) {
                    yield this.db.clearGroupUserActivity();
                    return;
                }
                if (this.onDisconnectGroupId !== groupId) {
                    (_a = this.onDisconnectHandler) === null || _a === void 0 ? void 0 : _a.cancel();
                    this.onDisconnectHandler = this.db.setGroupUserActivityOnDisconnect();
                    this.onDisconnectGroupId = groupId;
                }
                yield this.db.setGroupUserActivity({
                    documentKey,
                    focus: { tileIds }
                });
            })
        });
        this.db = db;
        this.flush = debounce(this.flushNow, kActivityDebounceDelay);
    }
    start() {
        const { ui, persistentUI, user } = this.db.stores;
        this.disposer = reaction(() => ({
            groupId: user.currentGroupId,
            documentKey: persistentUI.problemWorkspace.primaryDocumentKey,
            tileIds: ui.selectedTileIds.slice()
        }), () => this.flush(), { fireImmediately: true });
    }
    stop() {
        var _a;
        this.flush.cancel();
        (_a = this.disposer) === null || _a === void 0 ? void 0 : _a.call(this);
        this.disposer = null;
        const onDisconnectHandler = this.onDisconnectHandler;
        const onDisconnectGroupId = this.onDisconnectGroupId;
        this.onDisconnectHandler = null;
        this.onDisconnectGroupId = undefined;
        const clearActivity = onDisconnectGroupId
            ? this.db.clearGroupUserActivity().catch(() => undefined)
            : Promise.resolve();
        return clearActivity.finally(() => {
            void (onDisconnectHandler === null || onDisconnectHandler === void 0 ? void 0 : onDisconnectHandler.cancel());
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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